export const isArrayOfType = <T>(array: unknown, typeGuard: (value: unknown) => value is T): array is T[] => {
    return Array.isArray(array) && array.every(item => typeGuard(item))
}
